/* eslint-disable react/no-array-index-key */
import React from 'react';
import { FieldArray, useFormikContext } from 'formik';
import classnames from 'classnames';
import propTypes from 'prop-types';
import Input from '../../../components/Input';
import TextArea from '../../../components/TextArea';
import SubjectOptions from './SubjectOptions';
import Downloads from './AssemblyDownloads';

export default function AssemblySubject({ schema }) {
  const { values, handleChange, setFieldValue, errors, touched } = useFormikContext();
  return (
    <FieldArray
      name="subjects"
      render={({ push, remove }) => (
        <>
          {values.subjects.map((subject, index) => (
            <React.Fragment key={index}>
              <div className="justify-content-between d-flex">
                <h6>
                  Pauta&nbsp;
                  {index + 1}
                </h6>
                {values.subjects.length > 1 && (
                  <button className="btn btn-sm btn-outline-danger" type="button" onClick={() => remove(index)}>
                    Remover
                  </button>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="title">Nome</label>
                <Input
                  type="text"
                  value={subject.title}
                  onChange={handleChange}
                  name={`subjects[${index}].title`}
                  className={classnames(
                    errors.subjects &&
                      errors.subjects[index] &&
                      errors.subjects[index].title &&
                      touched.subjects &&
                      touched.subjects[index] &&
                      touched.subjects[index].title &&
                      'is-invalid',
                  )}
                />
              </div>
              <div className="form-group">
                <label htmlFor="title">Descrição</label>
                <TextArea
                  rows={5}
                  value={subject.description}
                  onChange={handleChange}
                  name={`subjects[${index}].description`}
                  className={classnames(
                    errors.subjects &&
                      errors.subjects[index] &&
                      errors.subjects[index].description &&
                      touched.subjects &&
                      touched.subjects[index] &&
                      touched.subjects[index].description &&
                      'is-invalid',
                  )}
                />
              </div>
              <label>Anexo</label>
              <Downloads files={subject.attachments} name={`subjects[${index}].attachments`} />
              <br />
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name={`subjects[${index}].hasVotes`}
                  id={`vote-${index}`}
                  value="true"
                  onChange={() => setFieldValue(`subjects[${index}].hasVotes`, true)}
                  checked={subject.hasVotes}
                />
                <label className="form-check-label" htmlFor={`vote-${index}`}>
                  Adicionar votação a pauta
                </label>
              </div>
              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="radio"
                  name={`subjects[${index}].hasVotes`}
                  id={`withoutVote-${index}`}
                  onChange={() => setFieldValue(`subjects[${index}].hasVotes`, false)}
                  value="false"
                  checked={!subject.hasVotes}
                />
                <label className="form-check-label" htmlFor={`withoutVote-${index}`}>
                  Pauta sem votação
                </label>
              </div>
              {subject.hasVotes && <SubjectOptions subject={subject} index={index} />}
              <br />
            </React.Fragment>
          ))}
          <button type="button" className="btn btn-block btn-outline-primary" onClick={() => push(schema.default())}>
            + adicionar outra pauta
          </button>
        </>
      )}
    />
  );
}

AssemblySubject.propTypes = {
  schema: propTypes.object.isRequired,
};
